module.exports = __webpack_public_path__ + "static/media/opSave.018956a8.png";